import { SendRequest } from '@weave/schema-gen-ts/dist/schemas/sms/send/v3/send_service.pb';
import { Direction, Encoding } from '@weave/schema-gen-ts/dist/schemas/sms/shared/v1/enums.pb';
import { SMS } from '@weave/schema-gen-ts/dist/schemas/sms/shared/v1/models.pb';
import { getUser } from '@frontend/auth-helpers';
import { formatPhoneNumberE164 } from '@frontend/phone-numbers';
import { genUUIDV4 } from '@frontend/string';
import { SENDING_STATUS_DATA } from '../../../constants';

export const convertSendRequestToSMS = (request: SendRequest & { threadId: string }): SMS => {
  const user = getUser();
  return {
    id: request.id || genUUIDV4(),
    providerMsgId: '',
    threadId: request.threadId,
    locationId: request.locationId,
    locationPhone: request.locationPhone ? formatPhoneNumberE164(request.locationPhone) : '',
    personPhone: request.personPhone ? formatPhoneNumberE164(request.personPhone) : '',
    direction: Direction.DIRECTION_OUTBOUND,
    body: request.body ?? '',
    status: SENDING_STATUS_DATA.status,
    statusDetails: SENDING_STATUS_DATA.statusDetails,
    numMedia: request.media?.length ?? 0,
    media: request.media ?? [],
    encoding: Encoding.ENCODING_UNSPECIFIED,
    segments: 1,
    relatedIds: request.relatedIds ?? [],
    labels: request.labels ?? {},
    programSlugId: request.programSlugId,
    personId: request.personId ?? '',
    deadline: request.deadline ?? '',
    autogeneratedBy: request.autogeneratedBy ?? '',
    readBy: request.createdBy || user?.userID || '',
    deletedBy: '',
    createdBy: request.createdBy || user?.userID || '',
    createdAt: new Date().toISOString(),
    updatedBy: '',
    updatedAt: '',
    readAt: new Date().toISOString(),
    deletedAt: '',
    actionable: false,
    departmentId: request.departmentId ?? '',
    tags: [],
    messageType: request.messageType,
    tagsDetailed: [],
  };
};
